module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/secondary-tile.de05f7ac.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/secondary-tile.png
// module id = 2587
// module chunks = 11